import { CaracteristiqueParcelle } from './caracteristique-parcelle.model';
import { UniteCulturaleVigne } from './unite-culturale-vigne.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class UniteCulturalePost {
    static jsonMap = {
        id: 'id',
        localisation: 'localisation',
        caracteristiqueParcelle: { key: 'caracteristiqueParcelle', converter: new (ClassConverterFactory.build(CaracteristiqueParcelle))() },
        uniteCulturaleVigne: { key: 'uniteCulturaleVigne', converter: new (ClassConverterFactory.build(UniteCulturaleVigne))() },
        numBlocFruitier: 'numBlocFruitier',
        numTracabilite: 'numTracabilite',
        codeParcelle: 'codeParcelle',
        espece: 'espece',
        variete: 'variete',
        anneePlantation: 'anneePlantation',
        anneePremiereFeuille: 'anneePremiereFeuille',
        anneeSurgreffage: 'anneeSurgreffage',
        distanceIntraRang: 'distanceIntraRang',
        distanceInterRang: 'distanceInterRang',
        nbArbre: 'nbArbre',
        confusion: 'confusion',
        porteGreffe: 'porteGreffe'
    };

    public id: number = undefined;
    public localisation: number = undefined;
    public caracteristiqueParcelle: CaracteristiqueParcelle = undefined;
    public uniteCulturaleVigne: UniteCulturaleVigne = undefined;
    public numBlocFruitier: string = undefined;
    public numTracabilite: string = undefined;
    public codeParcelle: string = undefined;
    public espece: number = undefined;
    public variete: number = undefined;
    anneePlantation: number;
    anneePremiereFeuille: number;
    anneeSurgreffage: number;
    distanceIntraRang: number;
    distanceInterRang: number;
    nbArbre: number;
    confusion: boolean;
    public porteGreffe: number = undefined;
}
